export default __webpack_public_path__ + "static/media/defaultImage.42ea05f9.svg";